import type { BaseDevice } from '../../../runtime/BaseDevice'
import { FirmwareFeature } from '../../../features/firmware/contract'
import { DeviceType, VersionType, type VersionInfo } from '../../../types/firmware'
import type { CH315KeyboardProtocol } from '../protocols'

export class CH315Firmware extends FirmwareFeature {
  constructor(
    device: BaseDevice,
    private readonly protocol: CH315KeyboardProtocol,
  ) {
    super(device)
  }

  async getFirmwareVersion(): Promise<VersionInfo[]> {
    const info = await this.protocol.getFirmwareInfo()
    return [
      {
        version: info.version,
        versionType: VersionType.MasterControl,
        deviceType: DeviceType.Keyboard,
        usbPid: info.usbPid,
      },
    ]
  }

  // checkFirmwareUpdate/updateFirmware intentionally inherit NOT_SUPPORTED:
  // A8 only enters bootloader and is not a safe updater implementation.
}
